@if (TornFilter != null) {
  <div style="float: right;width: 84%;">
    <div id="topSection">
      <div id="DBControls">
        <h2 id="DBHeading">{{Records.length}} </h2>
        <select id="ComboBox" name="TableSelector" [(ngModel)]="DataService.SelectedTable" (input)="tableChanged()">
          @for (table of Tables; track table) {
            <option [ngValue]="table">{{table}}</option>
          }
        </select>
        @if (UpdateMode === true) {
          <button type="Button" name="btnUpdate8" id="btnUpdate8" (click)="updateRecord()">Update</button>
        }
        @if (UpdateMode === true) {
          <button type="Button" name="btnDelete" id="btnDelete" (click)="deleteRow()">Delete Line</button>
        }
        @if (DataService.SelectedTable === 'Matches') {
          <button type="Button" name="btnProcess" id="btnProcess" (click)="processMatches()">Process All Matches</button>
        }
        @if (DataService.SelectedTable == 'Players') {
          <div style="display: inline-flex">
            <input type="file" id="ngexcelfile" />
            <input type="button" value="Read Player Data from Excel file" (click)="importFromXLSX()" />
          </div>
        }
        @if (DataService.SelectedTable == 'Entries' || DataService.SelectedTable === 'Matches' || DataService.SelectedTable === 'Draws') {
          <div id="TornFilterDiv">
            <label for="TornFilters">Torn filter: </label>
            <select id="TornFilters" name="TornFilters" [(ngModel)]="TornFilter" (input)="TornFilterChanged()">
              @for (torn of DataService.Torns; track torn) {
                <option [ngValue]="torn.id">{{torn.name}}</option>
              }
            </select>
            <h2 id="DBHeading">{{TotalFilteredResults}} </h2>
          </div>
        }
      </div>
      <br />
      <hr />
    </div>
    <table class="table">
      <thead>
        <tr>
          @for (column of columns; track column) {
            <td>
              {{column}}
            </td>
          }
        </tr>
      </thead>
      <tbody>
        @for (datum of Records; track datum) {
          <tr>
            @for (column of columns; track column) {
              <td >
                {{datum[column]}}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
<!-- <div id="DBControls">
<h2 id="DBHeading">{{Records.length}} </h2>
<select id="ComboBox" name="TableSelector" [(ngModel)]="SelectedTable" (input)="tableChanged()">
  <option *ngFor="table in Data.Tables" value="{{table}}">{{table}}</option>
</select>
<button type="Button" name="btnUpdate8" *ngIf="UpdateMode === true" id="btnUpdate8" (click)="updateRecord()">Update</button>
<button type="Button" name="btnDelete" *ngIf="UpdateMode === true" id="btnDelete" (click)="deleteRow()">Delete Line</button>
<button type="Button" name="btnProcess" *ngIf="SelectedTable === 'Matches'" id="btnProcess" (click)="processMatches()">Process All Matches</button>
<div *ngIf="SelectedTable == 'Players'" style="display: inline-flex">
  <input type="file" id="ngexcelfile" />
  <input type="button" value="Read Player Data from Excel file" (click)="importFromXLSX()" />
</div>

<div ng-show="SelectedTable == 'Entries' || SelectedTable === 'Matches' || SelectedTable === 'Draws'" id="TornFilterDiv">
  <label for="TornFilters">Torn filter: </label>
  <select id="TornFilters" name="TornFilters" [(ngModel)]="TornFilter.value" (input)="TornFilterChanged()">

    <option *ngFor="torn in Data.Torns" ng-value="torn.id">{{torn.Name}}</option>
  </select>
  <h2 id="DBHeading">{{TotalFilteredResults}} </h2>
</div>
</div>
<br />
<hr />

<div id="addItem" class="addItem">

</div>

<div id="newDB">
  <table id="table-layout" class="table-layout">
    <thead>
      <tr>
        <th *ngIf="data != 'id' && data != 'TornamentObject' && data != '__type' && data != 'Comments' && data != 'AccomodationInfo' && data != 'PrizeGivingInfo' && data != 'Players1' && data != 'Players2' && data != 'Matches' && data != 'Director' && data != 'FeesPaid' && data != 'Email' && data != 'Phone' && data != 'Province' && data != 'Country' && data != '$$hashKey' && data != 'Entries' && data != 'Draws' && data != 'Password'" ng-repeat="data in Fields" >{{data}}</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-show="(record.Tornament == TornFilter.value && SelectedTable == 'Entries') || (record.Torn == TornFilter.value && SelectedTable == 'Matches') || (record.Tornament == TornFilter.value && SelectedTable == 'Draws')|| (SelectedTable != 'Entries' && SelectedTable != 'Matches' && SelectedTable != 'Draws')" ng-repeat="record in Records">
        <td *ngIf="key_1 == 'DateOfEntry' || key_1 == 'DateOfEvent' || key_1 == 'ClosingDate' || key_1 == 'LastUpdate'" ng-repeat="(key_1, value_1) in record">{{value_1 | date: 'dd-MM-yyyy'}}</td>
        <td *ngIf="key_1 != 'id' && key_1 != 'TornamentObject' && key_1 != '__type' && key_1 != 'Comments' && key_1 != 'AccomodationInfo' && key_1 != 'PrizeGivingInfo' && key_1 != 'Players1' && key_1 != 'Players2' && key_1 != 'Director' && key_1 != 'Matches' && key_1 != 'FeesPaid' && key_1 != 'Email' && key_1 != 'DateOfEntry' && key_1 != 'DateOfEvent' && key_1 != 'ClosingDate' && key_1 != 'Phone' && key_1 != 'Province' && key_1 != 'Country'  && key_1 != '$$hashKey' && key_1 != 'Entries' && key_1 != 'DoublesPlayers' && key_1 != 'SinglesPlayers' && key_1 != 'Draws' && key_1 != 'Password'" ng-repeat="(key_1, value_1) in record" >{{value_1}}</td>
      </tr>
    </tbody>
  </table>
</div> -->
